import { InjectionToken } from "@angular/core";
import { StaffPayrollPort } from "./staff-payroll.port";

export const STAFF_PAYROLL_PORT = new InjectionToken<StaffPayrollPort>(
  "STAFF_PAYROLL_PORT",
);
